import "./index.scss";
import { Component, Vue } from "vue-property-decorator";
import ContractApi from "@/api/contract";
import { RepaymentModel } from "@/po/ProductResult";
import { session } from "@/shared/utils/storage";
import { LoanEvidence } from "@/api/contract/types";

@Component({ name: "BorrowTableContract" })
export default class BorrowTableContract extends Vue {
  private infos: LoanEvidence | null = null;

  private repaymentModelName = RepaymentModel.EPAI;

  private async created() {
    const applyContractForm = session.get("applyProductForm") as {
      productId: string;
      bankCardId: string;
      amount: number;
      period: number;
      usage: string;
    };

    if (applyContractForm) {
      this.infos = await ContractApi.contractInfo(
        applyContractForm.productId,
        "",
        applyContractForm.bankCardId
      );

      this.infos.amount = applyContractForm.amount;
      this.infos.period = applyContractForm.period;
      this.infos.loanUsage = applyContractForm.usage;
    }
  }

  private getInfoProp(
    propName: keyof LoanEvidence,
    defaultValue?: string
  ): string | number {
    const keyValue = (this.infos || {})[propName];

    if (
      typeof keyValue === "undefined" ||
      keyValue === null ||
      keyValue === ""
    ) {
      return defaultValue || "______";
    }

    return keyValue;
  }

  private renderDate() {
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  private render() {
    return (
      <div
        class="contractTable"
        style="width:100%;height:100%;overflow-y:scroll;"
      >
        <p class="p1" style="text-align: center; font-size: 16px;">
          <strong>个人借款电子借据</strong>
        </p>
        <p class="p3" style="text-align: right;">
          <span class="s1">
            <strong>编号：</strong>
          </span>
          <strong>
            <span class="Apple-converted-space">
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            </span>
          </strong>
        </p>
        <div class="grid">
          <div class="item">
            <strong>借款人</strong>
          </div>
          <div class="item">
            <p class="p5">
              <span class="s2">【{this.getInfoProp("userName")}】</span>
            </p>
          </div>

          <div class="item">
            <strong>身份证号</strong>
          </div>
          <div class="item">
            <p class="p5">
              <span class="s2">【{this.getInfoProp("idCard")}】</span>
            </p>
          </div>

          <div class="item">
            <strong>联系电话</strong>
          </div>
          <div class="item">
            <p class="p5">
              <span class="s2">【{this.getInfoProp("phone")}】</span>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>联系邮箱</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">
              <span class="s2">
                【
                {this.getInfoProp("email", "") ||
                  this.getInfoProp("companyEmail")}
                】
              </span>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>联系地址</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">
              <span class="s2">【{this.getInfoProp("adress")}】</span>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>贷款人</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">杭银消费金融股份有限公司</p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>借款本金</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">人民币 {this.getInfoProp("amount")}</p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>借款用途</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">
              个人消费贷款：{" "}
              <span class="s2">{this.getInfoProp("loanUsage")}</span>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>借款月费率</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">
              <span class="s3">
                <span class="Apple-converted-space">&nbsp; </span>
              </span>
              <span class="s2">{this.getInfoProp("monthRate")}</span>{" "}
              <span class="s4">%</span>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>分期期数</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">
              <span class="s2">&nbsp; {this.getInfoProp("period")}</span> 期
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>放款方式</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">
              <strong>自主支付</strong>
            </p>
            <p class="p6">
              <span class="s4">
                <strong>1.</strong>
              </span>
              <strong>收款账户信息</strong>
            </p>
            <p class="p6">
              收款账户户名：{" "}
              <span class="s2">【{this.getInfoProp("userName")}】</span>
            </p>
            <p class="p6">
              银行账号：
              <span class="s3">
                <span class="Apple-converted-space">&nbsp; </span>
              </span>
              <span class="s2">【{this.getInfoProp("bankCardNo")}】</span>
              <span class="s3">&nbsp;</span>
            </p>
            <p class="p6">
              开户行：
              <span class="s3">
                <span class="Apple-converted-space">&nbsp; </span>
              </span>
              <span class="s2">【{this.getInfoProp("bankName")}】</span>
              <span class="s3">
                {" "}
                <span class="Apple-converted-space">&nbsp; &nbsp;</span>
              </span>
            </p>
            <p class="p7">
              <strong>2.发放方式：一次性发放</strong>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>放款日</strong>
            </p>
          </div>
          <div class="item">
            <p class="p8">{this.renderDate()}</p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>还款方式</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">{this.repaymentModelName}</p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>期款</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5">
              以还款计划表或<span class="s4">App</span>展示为准
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>固定还款日</strong>
            </p>
          </div>
          <div class="item">
            <p class="p8">
              <span class="s1">{this.getInfoProp("dueDate")}日</span>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>首次还款日</strong>
            </p>
          </div>
          <div class="item">
            <p class="p8">
              <span class="s1">{this.getInfoProp("firstDueDate")}</span>
            </p>
          </div>

          <div class="item">
            <p class="p4">
              <strong>提前还款违约金</strong>
            </p>
          </div>
          <div class="item">
            <p class="p5" style="width: 274px;">
              =当笔借据剩余本金<span class="s4">*2%</span>
            </p>
          </div>
        </div>
        <p class="p9">&nbsp;</p>
        <p class="p1">
          <strong>借款人：</strong>
          <span class="s5">
            <strong>
              <span>{this.getInfoProp("userName")}</span>
            </strong>
          </span>
        </p>
        <p>
          <strong>贷款人：杭银消费金融股份有限公司</strong>
        </p>
        <p class="p10">
          <span class="s7">
            <strong>日期：</strong>
          </span>
          <strong>{this.renderDate()}</strong>
        </p>
        <p>&nbsp; </p>
        <p>&nbsp; </p>
        <p>&nbsp; </p>
      </div>
    );
  }
}
